import React from 'react'
import { FormatNumberMXN } from "../../common/Utils";

export const ColumnsDetailOrder = (t) => (
    [
        {
            name: t('OrderDetailDashboard.ColumnVIN'),
            columnheader: {textAlign: 'center'},
            selector: 'vin',
            sortable: true,
            width: "170px",
            cell: row => row.vin
        },
        {
            name: t('OrderDetailDashboard.ColumnService'),
            selector: 'service',
            columnheader: {textAlign: 'center'},
            sortable: true,
            cell: row => row.service
        },
        {
            name: t('OrderDetailDashboard.ColumnSubtotal'),
            selector: 'subtotal',
            columnheader: {textAlign: 'center'},
            sortable: true,
            right: true,
            width: "150px",            
            cell: row => FormatNumberMXN(row.subtotal)
        }      
    ]
)

  